import { render } from "./SecurityProAppInformation.vue?vue&type=template&id=2db130de"
import script from "./SecurityProAppInformation.vue?vue&type=script&lang=js"
export * from "./SecurityProAppInformation.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/docker/vpn/odessa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__